import React from 'react';
import Header from './Header';
import projects from '../json/projects.json';
import { motion } from 'framer-motion';

import drawboard from '../assets/pro_aim_drawboard.png';
import graphics from '../assets/pro_aim_graphics.png';
import player from '../assets/pro_aim_player.png';
import social_media from '../assets/pro_aim_social_media.png';
import tetris from '../assets/pro_aim_tetris.png';
import hotel from '../assets/pro_aim_hotel.png';
import aimikel from '../assets/pro_aim_mikel.png';
import app from '../assets/pro_aim_app.png';
import software from '../assets/pro_aim_software.png';
import chat from '../assets/pro_aim_chat.png';
import puresoft from '../assets/pro_aim_puresoft.png';
import v_control from '../assets/project_version_control.png';

function Projects() {
	const images = [social_media, app, graphics, player, tetris, drawboard, hotel, aimikel, software, chat, puresoft, v_control];

	return (
		<React.Fragment>
			<Header appTitle="Projects" />
			<div className="main-body projects-page pd-md-v xl-pd-none">
				<h4 className="sp-xl-bottom pd-xl-h blob-b blob-t">The projects that I have listed here are just but a few of the many stuffs I have been doing. Some are complete while others are still ongoing. You can find source code of some of the projects on github while others are private and no source code is available for public viewing.</h4>
				<div className="projects grid sm-grid-2 lg-grid-3">
					{projects.map((project, index) => {
						return (
							<motion.div layout key={index} className="each-project flex flex-column elevate bg-light">
								<a href={images[index]}>
									<motion.div whileHover={{ backgroundSize: '130%', transition: { duration: 0.5 } }} className="header bg-default" style={{ backgroundImage: 'url(' + images[index] + ')' }}></motion.div>
								</a>
								<div className="footer pd flex flex-column flex-grow">
									<h4 className="txt-primary">{project.title}</h4>
									<p className="txt-fade">Category: {project.category}</p>
									<p className="flex-grow">{project.description}</p>
									{project.url && (
										<a className="pd-h md txt-underline" target="_blank" rel="noreferrer" href={project.url}>
											{project.url}
										</a>
									)}
								</div>
							</motion.div>
						);
					})}
				</div>
				<h4 className="txt-fade sp-xl-top pd-lg-h blob-b blob-t">
					<i> I will be updating the list with time with my current projects. Keep checking for new and awesome projects.</i>
				</h4>
			</div>
		</React.Fragment>
	);
}

export default Projects;
